import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  Typography,
} from '@pebl/ui';
import clsx from 'clsx';

import log from '@/utils/logging';

import { CommonActionPropertyViewProps } from '../../types';

export type ActionPropertySelectItemData = {
  value: string;
  displayText: string;
};

export function ActionPropertySelectView({
  defaultValue,
  disabled,
  error,
  helperText,
  innerRef,
  items,
  label,
  name,
  onChange,
  placeholder,
  required,
  value,
}: {
  error?: boolean;
  label?: string;
  placeholder?: string;
  helperText?: string;
  items: ActionPropertySelectItemData[];
} & CommonActionPropertyViewProps<string>) {
  return (
    <div className="qng-action-property-select flex flex-col">
      <Select
        value={value}
        defaultValue={defaultValue}
        onValueChange={(val) => {
          log.debug('Action Select value changed', val);
          onChange?.(val);
        }}
        name={name}
        required={required}
        disabled={disabled}
        // Data Fields - Primarily for debugging / testing
        data-action-option-type="object"
        data-action-option-format="select"
      >
        <SelectTrigger
          placeholder={placeholder}
          label={label}
          className="qng-action-property-select-trigger"
          ref={innerRef}
          error={error}
        />
        <SelectContent className="qng-action-property-select">
          {items.map((item) => (
            <SelectItem
              key={item.value}
              value={item.value}
              displayText={item.displayText}
            />
          ))}
        </SelectContent>
      </Select>
      {helperText && (
        <Typography
          variant="caption"
          className={clsx(error ? 'text-red-500' : undefined)}
        >
          {helperText}
        </Typography>
      )}
    </div>
  );
}
